import React from 'react';
import { StarIcon } from 'lucide-react';
export const Header = () => {
  return <header className="mb-8" data-id="element-399">
      <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight" data-id="element-400">
        US Pest Control Expert Reveals Strange Trick To Eliminate All Roaches
        and Mice. I Haven't Seen a Single Pest Since I Plugged It In.
      </h1>

      <p className="text-xl mb-4" data-id="element-401">
        <span className="bg-yellow-200 px-1 font-bold" data-id="element-402">
          Did you know there's a new plug-in device that uses variable frequency
          technology to keep pests out of your home permanently?
        </span>
      </p>

      <div className="mb-4" data-id="element-403">
        <p className="text-sm text-gray-600 mb-2" data-id="element-404">By Michael Torres</p>
        <p className="text-sm text-gray-500" data-id="element-405">
          ✓ Home & Living | November 16th, 2025 | 9:17 AM EST
        </p>
      </div>

      <div className="flex items-center gap-2" data-id="element-406">
        <div className="flex" data-id="element-407">
          {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} className={i < 4 ? 'fill-yellow-400 text-yellow-400' : 'fill-yellow-400 text-yellow-400 opacity-50'} data-id="element-408" />)}
        </div>
        <span className="text-blue-600 font-medium text-lg" data-id="element-409">4,354 Ratings</span>
      </div>
    </header>;
};